import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import assetMastersSliceService from "services/Setup/Organization/assetMaseterService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  assetMastersSliceList: [],
};

export const getassetMastersSliceList = createAsyncThunk(
  "assetMastersSlice/getassetMastersSliceList",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~getassetMastersSliceList data:", data);
    try {
      const response = await assetMastersSliceService.getAssetMaster(data);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getSearchAssetMastersSliceList = createAsyncThunk(
  "assetMastersSlice/getSearchAssetMastersSliceList",
  async (data, { rejectWithValue }) => {
    // console.log("🚀 ~getSearchAssetMastersSliceList data:", data);
    try {
      const response =
        await assetMastersSliceService.getSearchAssetMastersSliceList(data);
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const assetMastersSlice = createSlice({
  name: "assetMastersSlice",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get assetCategory code list
      .addCase(getSearchAssetMastersSliceList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSearchAssetMastersSliceList.fulfilled, (state, action) => {
        state.loading = false;
        state.assetMastersSliceList = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getSearchAssetMastersSliceList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get assetCategory code list
      .addCase(getassetMastersSliceList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getassetMastersSliceList.fulfilled, (state, action) => {
        state.loading = false;
        state.assetMastersSliceList = action.payload?.data;
        state.getCount = action.payload.count;
      })
      .addCase(getassetMastersSliceList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  assetMastersSlice.actions;

export default assetMastersSlice.reducer;
